"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EatsAppIcon = void 0;
/* eslint-disable max-len */
var react_1 = __importStar(require("react"));
var Icon_1 = require("./Icon");
exports.EatsAppIcon = (0, react_1.forwardRef)(function EatsAppIcon(props, ref) {
    return (react_1.default.createElement(Icon_1.Icon, __assign({ ref: ref, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("rect", { width: "24", height: "24", rx: "5", fill: "#FBDF5A" }),
        react_1.default.createElement("path", { d: "M18.8085 18.5071C17.2221 19.7039 15.3018 20.3579 13.3188 20.3579C10.967 20.3579 8.76832 19.4604 7.13322 17.8253C5.53291 16.2249 4.64926 14.1237 4.64926 11.9111C4.64926 7.57632 8.07949 4.04868 12.296 4.04868C14.2094 4.04868 15.9975 4.77229 17.3265 6.08733C18.6346 7.38149 19.3512 9.07922 19.3512 10.8813C19.3512 14.3254 16.6446 17.1295 13.3257 17.1295C10.3269 17.1295 7.88467 14.7847 7.88467 11.9111C7.88467 9.35753 9.86766 7.27713 12.296 7.27713C14.4042 7.27713 16.1228 8.89831 16.1228 10.8813C16.1228 12.5442 14.8634 13.901 13.3257 13.901C11.962 13.901 11.1131 12.8643 11.1131 11.9111C11.1131 11.1387 11.6419 10.5056 12.296 10.5056C12.616 10.5056 12.8387 10.6795 12.8874 10.8256C12.6856 10.9787 12.5743 11.2362 12.616 11.5075C12.6786 11.9041 13.0474 12.1755 13.437 12.1128C13.9519 12.0363 14.3416 11.5075 14.3416 10.8883C14.3416 9.88633 13.4231 9.0653 12.296 9.0653C10.8487 9.0653 9.66588 10.3455 9.66588 11.918C9.66588 13.8106 11.3079 15.3552 13.3257 15.3552C15.6636 15.3552 17.57 13.3513 17.57 10.8883C17.57 8.10511 15.2043 5.83685 12.296 5.83685C9.06751 5.83685 6.43743 8.56433 6.43743 11.918C6.43743 15.5918 9.52673 18.5837 13.3257 18.5837C17.4448 18.5837 20.7985 15.1326 20.7985 10.8883C20.7985 8.69653 19.9287 6.63005 18.3423 5.06453C16.742 3.47813 14.5921 2.6084 12.296 2.6084C7.28629 2.6084 3.20898 6.78312 3.20898 11.918C3.20898 14.5203 4.23875 16.9834 6.11737 18.855C8.02383 20.7615 10.5843 21.8121 13.3257 21.8121C15.6288 21.8121 17.8623 21.0537 19.6991 19.6621L18.8085 18.5071Z", fill: "#21211F" })));
});
